import * as Yup from 'yup';
import AcceptanceTermsType from '../entities/acceptance-term-type';

export interface TermForm {
  termType: AcceptanceTermsType | null;
  version: string;
  url: any;
}

export type TermFormShape = {
  [key in keyof TermForm]?: any;
};

export const schema = Yup.object().shape<TermFormShape>({
  termType: Yup.string().required('É necessário selecionar um tipo'),
  version: Yup.string().required('É necessário informar a versão'),
  url: Yup.mixed().required('É necessário fazer o upload do arquivo'),
});
